import React from 'react'
import { Switch } from 'react-router'
import { Router as BrowserRouter, Redirect } from 'react-router-dom'
import { PageArtificialTellsAnswers } from '../../artificialTells/components/PageArtificialTellsAnswers'
import { PageArtificialTellsGroupDetails } from '../../artificialTells/components/PageArtificialTellsGroupDetails'
import { PageArtificialTellsGroups } from '../../artificialTells/components/PageArtificialTellsGroups'
import { PageArtificialTellsSearch } from '../../artificialTells/components/PageArtificialTellsSearch'
import { ContentContainer } from '../../common'
import { Alert } from '../../common/components/Alert'
import { Modal } from '../../common/components/Modal'
import { PopupModal } from '../../common/components/PopupModal'
import { RenderModal } from '../../common/components/RenderModal'
import { Text } from '../../common/components/Text'
import { View } from '../../common/components/View'
import { history } from '../../common/history'
import { PageRecentAnswers } from '../../dashboards/components/PageRecentAnswers'
import { PageLastBlocked } from '../../filter/components/PageLastBlocked'
import { PageLastDetectedSpam } from '../../filter/components/PageLastDetectedSpam'
import { PageSpamItemInfo } from '../../filter/components/PageSpamItemInfo'
import { Index } from '../../index/pages/Index'
import { PageAccountVerification } from '../../moderator/components/PageAccountVerification'
import { PageBanCandidates } from '../../moderator/components/PageBanCandidates'
import { PageBannedDevices } from '../../moderator/components/PageBannedDevices'
import { PageBlacklist } from '../../moderator/components/PageBlacklist'
import { PageModeration } from '../../moderator/components/PageModeration'
import { PageNsfwPictures } from '../../moderator/components/PageNsfwPictures'
import { PageResult } from '../../moderator/components/PageResult'
import { PageSearch } from '../../moderator/components/PageSearch'
import { PageChCompare } from '../../statistics/components/PageChCompare'
import { PageChDiff } from '../../statistics/components/PageChDiff'
import { PageClickhouseEvents } from '../../statistics/components/PageClickhouseEvents'
import { PageCsv } from '../../statistics/components/PageCsv'
import { PageDiff } from '../../statistics/components/PageDiff'
import { PageExperiment } from '../../statistics/components/PageExperiments'
import { PageUpload } from '../../statistics/components/PageUpload'
import { PageAnalyticsE2E } from '../../tools/components/PageAnalyticsE2E'
import { PageAnalyticsInfo } from '../../tools/components/PageAnalyticsInfo'
import { PageBadwordscore } from '../../tools/components/PageBadwordscore'
import { PageExperimentsTools } from '../../tools/components/PageExperimentsTools'
import { PageNotionHelpers } from '../../tools/components/PageNotionHelpers'
import { PageProfileVisualiser } from '../../tools/components/PageProfileVisualiser'
import { PageQueryBuilder } from '../../tools/components/PageQueryBuilder'
import { PageTiktokVideoGenerator } from '../../tools/components/PageTiktokVideoGenerator'
import { IfAuthenticated } from '../../user/components/IfAuthenticated'
import { IfLoaded } from '../../user/components/IfLoaded'
import { PageLogin } from '../../user/components/PageLogin'
import { Header } from './Header'
import { Route } from './Route'
import { SideMenu } from './SideMenu'

const NotFound = () => (
  <ContentContainer>
    <View
      style={{
        flex: 1,
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      <Text center type="h1">
        {'Nothing here, yet ¯\\_(ツ)_/¯'}
      </Text>
    </View>
  </ContentContainer>
)

export const Router = () => (
  <IfLoaded>
    <BrowserRouter history={history}>
      <View style={{ height: '100%', flex: 1 }}>
        <Alert />
        <IfAuthenticated renderElse={() => <View />}>
          <Header />
          <RenderModal />
          <PopupModal />
          <Modal />
        </IfAuthenticated>

        <SideMenu>
          <Switch>
            <Redirect
              exact
              from="/management/artificialtells"
              to="/artificialtells"
            />
            <Redirect
              exact
              from="/artificialtells"
              to="/artificialtells/en/list"
            />
            <Route
              exact
              path="/"
              authenticated={Index}
              unauthenticated={PageLogin}
            />
            <Route
              exact
              path="/ban/candidates/:tab?"
              authenticated={PageBanCandidates}
            />
            <Route
              exact
              path="/ban/devices"
              authenticated={PageBannedDevices}
            />
            <Route
              exact
              path="/blacklist/:tab?"
              authenticated={PageBlacklist}
            />
            <Route
              exact
              path="/dashboards/recentanswers"
              authenticated={PageRecentAnswers}
            />
            <Route exact path="/search/:type?" authenticated={PageSearch} />
            <Route exact path="/moderation" authenticated={PageModeration} />
            <Route
              exact
              path="/accountverification"
              authenticated={PageAccountVerification}
            />
            <Route
              exact
              path="/nsfwpictures"
              authenticated={PageNsfwPictures}
            />
            <Route exact path="/lastblocked" authenticated={PageLastBlocked} />
            <Route exact path="/spam" authenticated={PageLastDetectedSpam} />
            <Route
              exact
              path="/spam/:spamItemId"
              authenticated={PageSpamItemInfo}
            />
            <Route
              exact
              path="/artificialtells/search"
              authenticated={PageArtificialTellsSearch}
            />
            <Redirect
              exact
              from="/artificialtells/:lang"
              to="/artificialtells/:lang/list"
            />
            <Route
              exact
              path="/artificialtells/:language/group/:groupId"
              authenticated={PageArtificialTellsGroupDetails}
            />
            <Route
              exact
              path="/artificialtells/:artificialTellId/answers"
              authenticated={PageArtificialTellsAnswers}
            />
            <Route
              exact
              path="/artificialtells/:language/:tab"
              authenticated={PageArtificialTellsGroups}
            />
            <Route exact path="/stats/ch/diff" authenticated={PageChDiff} />
            <Route
              exact
              path="/stats/ch/compare"
              authenticated={PageChCompare}
            />
            <Route exact path="/stats/diff" authenticated={PageDiff} />
            <Route
              exact
              path="/stats/chevents"
              authenticated={PageClickhouseEvents}
            />
            <Route exact path="/stats/csv" authenticated={PageCsv} />
            <Route exact path="/stats/upload" authenticated={PageUpload} />
            <Route
              exact
              path="/stats/experiment"
              authenticated={PageExperiment}
            />
            <Route
              exact
              path="/tools/analyticse2e"
              authenticated={PageAnalyticsE2E}
            />
            <Route
              exact
              path="/tools/analyticsinfo"
              authenticated={PageAnalyticsInfo}
            />
            <Route
              exact
              path="/tools/badwordscore"
              authenticated={PageBadwordscore}
            />
            <Route
              exact
              path="/tools/experiments"
              authenticated={PageExperimentsTools}
            />
            <Route
              exact
              path="/tools/notionhelpers"
              authenticated={PageNotionHelpers}
            />
            <Route
              exact
              path="/tools/profilevisualiser"
              authenticated={PageProfileVisualiser}
            />
            <Route
              exact
              path="/tools/querybuilder"
              authenticated={PageQueryBuilder}
            />
            <Route
              exact
              path="/tools/generatetiktokvideo"
              authenticated={PageTiktokVideoGenerator}
            />
            <Route exact path="/user/:id" authenticated={PageResult} />
            <Route component={NotFound} />
          </Switch>
        </SideMenu>
      </View>
    </BrowserRouter>
  </IfLoaded>
)
